export { default } from './WorldTaxonomy';
